import { Action } from 'redux';

import { DiscardDraftFailed, DiscardDraftRequested, DiscardDraftSucceeded, RemoveDraftFromContentInfo } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { ExplorableItemType } from '../../ts/models/ContentType';
import { DraftsTelemetry } from '../telemetry/DraftsTelemetry';


export interface DiscardDraftRequestedAction extends Action {
  draftLuid: string;
  contentType: ExplorableItemType;
  parentLuid: string;
  name: string;
  locationOrigin: DraftsTelemetry.LocationOrigin;
}

export interface DiscardDraftSucceededAction extends Action {
  draftLuid: string;
}

export interface DiscardDraftFailedAction extends Action {
  error: Error;
}

export interface RemoveDraftFromContentInfoAction extends Action {
  contentType: ExplorableItemType;
  contentId: string;
}

export function discardDraftRequestedAction(actionProps: Omit<DiscardDraftRequestedAction, 'type'>): DiscardDraftRequestedAction {
  return {
    type: DiscardDraftRequested,
    ...actionProps
  };
}

export function discardDraftSucceededAction(draftLuid: string): DiscardDraftSucceededAction {
  return {
    type: DiscardDraftSucceeded,
    draftLuid
  };
}

export function discardDraftsFailed(e: Error): DiscardDraftFailedAction {
  return {
    type: DiscardDraftFailed,
    error: e,
  };
}

export function removeDraftFromContentInfo(contentId: string, contentType: ExplorableItemType): RemoveDraftFromContentInfoAction {
  return {
    type: RemoveDraftFromContentInfo,
    contentType,
    contentId
  };
}

export const isDiscardDraftSucceededAction = isActionFactory<DiscardDraftSucceededAction>(DiscardDraftSucceeded);
export const isRemoveDraftFromContentInfoAction = isActionFactory<RemoveDraftFromContentInfoAction>(RemoveDraftFromContentInfo);
